const NotFound = () => {
  return <h6>404: The page you are looking for isn’t here</h6>;
};

export default NotFound;
